export { default, default as Disclaimer } from "./Disclaimer";
